module.exports = __webpack_public_path__ + "static/fipcbluewhale3-140f6f7c4259e911c8b2e722d50dafaf.jpeg";